import clsx from 'clsx';
import type { CSSProperties, FunctionComponent } from 'react';

export type SpinnerSize = 'md' | 'sm';

/**
 * `sm` carries a trailing margin because it is almost always inline next to a label. `md` stands on its
 * own, so it has none and the caller controls the spacing.
 */
const sizeClasses: Record<SpinnerSize, string> = {
    md: 'h-[20px] w-[20px] border-2',
    sm: 'h-[12px] w-[12px] border-2 mr-xs',
};

export const Spinner: FunctionComponent<{
    readonly className?: string;
    readonly size?: SpinnerSize;
    readonly style?: CSSProperties;
}> = ({ className, size = 'sm', style }) => (
    <div
        className={clsx('rounded-full border-transparent border-t-current animate-spin', sizeClasses[size], className)}
        data-testid="spinner"
        style={style}
    />
);
